//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { LocalizationHelper, ConfigHelper } from "../../../../helpers"

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"


export class DataTypeClassDateTimeRule implements IDataTypePanelRule {

    private static get dataTypeClass(): number { return Enums.DataTypeClass.Datetime }


    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>()
            .resolve(opDataType != null && (opDataType.idDataTypeClass === Enums.DataTypeClass.Datetime || opDataType.idDataTypeClass === Enums.DataTypeClass.Date))
            .promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        const dateFormat: ConfigHelper.DateFormat = opDataType.idDataTypeClass === DataTypeClassDateTimeRule.dataTypeClass ? ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX : ConfigHelper.DateFormat.DATE_FORMAT_DX

        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxDateBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    displayFormat: ConfigHelper.getDateFormat(dateFormat),
                    type: opDataType.idDataTypeClass === DataTypeClassDateTimeRule.dataTypeClass ? 'datetime' : 'date',
                    width: "100%",
                    value: _.first(data)
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods 

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }


    //#endregion

}